import { useCallback } from "react";

// Helpers
import { useTranslate } from "helpers";

// UI
import VehicleLocationFields from "ui/modules/fleet/vehicles/pages/components/VehicleLocationFields/VehicleLocationFields";
import { pickLocationErrors } from "ui/modules/fleet/vehicles/pages/components/VehicleLocationFields/errors";

// Servisni sloj
import { initialVehicleLocationForm } from "services/api/fleet/vehicles/locations/consts";
import { VehicleLocationFormValues } from "services/api/fleet/vehicles/locations/types";

import { VehicleLocationFormProps } from "./types";

/**
 * Korak "Lokacija" — gdje se vozilo fizički nalazi u trenutku unosa.
 * Korak je neobavezan (tenant ga može isključiti u postavkama), ali kad je uključen,
 * vrsta lokacije i njezin nositelj se moraju odabrati.
 */
const VehicleLocationForm: React.FC<VehicleLocationFormProps> = (props) => {
  const { formValues, setFormValues, errors } = props;

  const { t } = useTranslate();

  // Vozila unesena prije uvođenja lokacija je nemaju — forma tada kreće od praznog obrasca.
  const locationValues = formValues.location ?? initialVehicleLocationForm;

  const handleLocationChange = useCallback(
    (location: VehicleLocationFormValues) => {
      setFormValues((prev) => ({ ...prev, location }));
    },
    [setFormValues]
  );

  return (
    <div className="flex items-center justify-center px-4 pt-12 pb-6">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
          {t("admin.fleet.vehicle.edit.location.title")}
        </h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto">
          Odredite gdje se vozilo trenutno nalazi. Kasnije se mijenja premještajem, pa
          ostaje zapisano gdje je vozilo kada bilo.
        </p>
        <form noValidate className="border bg-white border-slate-200">
          <div className="py-6 px-4">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">
                {t("admin.fleet.vehicle.add.location.title")}
              </h3>
              <p className="text-xs text-slate-500">Gdje se vozilo trenutno nalazi</p>
            </div>
            <VehicleLocationFields
              values={locationValues}
              errors={pickLocationErrors(errors)}
              onChange={handleLocationChange}
              showValidFrom={false}
              showNote={false}
              layout="grid"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default VehicleLocationForm;
